/*
 * Modern Standard Coffee — Quick add for coffee cards (draft 25, 15 Oct 2026)
 *
 * "Quick add +" on a coffee card opens a panel (a bottom sheet on phones, a
 * small window on bigger screens) with the coffee's size (or Bag 1 / Bag 2)
 * and grind, then adds it to the basket without leaving the page. Same idea
 * as RAVE's quick add.
 *
 * - Product data comes from /products/<handle>.js, so prices and stock are live.
 * - Grind is sent as the line-item property "Grind" with exactly the same
 *   values as the product page, so the roastery sees the same thing on orders.
 * - One-time purchase only. Subscriptions stay on the product page.
 * - After adding, the basket count in the header refreshes and the panel
 *   offers "View basket" or "Keep shopping".
 */
(function () {
  if (window.__mscQuickAdd) return;
  window.__mscQuickAdd = true;

  var GRINDS = [
    { value: 'Whole bean', label: 'Whole bean' },
    { value: 'Aeropress', label: 'Aeropress' },
    { value: 'Cafetiere (coarse ground)', label: 'Cafetiere' },
    { value: 'Espresso (fine ground)', label: 'Espresso' },
    { value: 'Pour over (medium ground)', label: 'Pour over' }
  ];
  var money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  var fmt = function (p) { return money.format(p / 100); };
  var esc = function (s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  var sheet, panel, lastOpener, state = null;

  function build() {
    if (sheet) return;
    sheet = document.createElement('div');
    sheet.className = 'msc-qa-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="msc-qa-sheet__backdrop" data-msc-qa-close></div>' +
      '<div class="msc-qa-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="msc-qa-title" tabindex="-1"></div>';
    document.body.appendChild(sheet);
    panel = sheet.querySelector('.msc-qa-sheet__panel');
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-msc-qa-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) close();
    });
  }

  function open(btn) {
    build();
    lastOpener = btn;
    var url = btn.getAttribute('data-msc-qa-url');
    var showGrind = btn.getAttribute('data-msc-qa-grind') !== 'false';
    btn.classList.add('is-loading');
    btn.setAttribute('aria-disabled', 'true');
    fetch(url.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (product) {
        var first = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
        state = {
          product: product,
          url: url.split('?')[0],
          showGrind: showGrind,
          picked: (first.options || []).slice(),
          grind: GRINDS[0].value
        };
        render();
        sheet.hidden = false;
        document.documentElement.classList.add('msc-qa-open');
        requestAnimationFrame(function () { sheet.classList.add('is-open'); panel.focus(); });
      })
      .catch(function () { window.location.href = url; })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-disabled');
      });
  }

  function close() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('msc-qa-open');
    setTimeout(function () { sheet.hidden = true; panel.innerHTML = ''; }, 200);
    if (lastOpener) lastOpener.focus();
  }

  function currentVariant() {
    var p = state.product;
    return p.variants.filter(function (v) {
      return (v.options || []).every(function (o, i) { return o === state.picked[i]; });
    })[0];
  }

  function priceFor(optIndex, value) {
    // Price shown under a button: only when the product has a single option (e.g. Size).
    var p = state.product;
    if (p.options.length !== 1) return '';
    var v = p.variants.filter(function (x) { return x.options[optIndex] === value; })[0];
    return v ? fmt(v.price) : '';
  }

  function render(addedMsg) {
    var p = state.product;
    var v = currentVariant();
    var single = p.variants.length === 1 && p.options.length === 1 && p.options[0].values.length === 1;
    var html = '';
    html += '<div class="msc-qa__head">' +
      '<h2 id="msc-qa-title" class="msc-qa__title">' + esc(p.title) + '</h2>' +
      '<button type="button" class="msc-qa__x" data-msc-qa-close aria-label="Close">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '</div>';
    html += '<p class="msc-qa__price" data-msc-qa-price>' + (v ? fmt(v.price) : '') + '</p>';

    if (!single) {
      p.options.forEach(function (opt, i) {
        var name = typeof opt === 'string' ? opt : opt.name;
        var values = typeof opt === 'string' ? [] : opt.values;
        html += '<fieldset class="msc-qa__field"><legend class="msc-qa__legend">' + esc(name) + '</legend>' +
          '<div class="msc-qa__opts' + (values.length > 4 || name.indexOf('Bag') === 0 ? ' msc-qa__opts--two' : '') + '">';
        values.forEach(function (val) {
          var on = state.picked[i] === val;
          var pr = priceFor(i, val);
          var free = false;
          if (p.options.length === 1) {
            var vv = p.variants.filter(function (x) { return x.options[i] === val; })[0];
            free = vv && vv.price >= 3000;
          }
          html += '<button type="button" class="msc-qa__opt' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-msc-qa-opt="' + i + '" data-val="' + esc(val) + '">' +
            '<span class="msc-qa__opt-name">' + esc(val) + '</span>' +
            (pr ? '<span class="msc-qa__opt-price">' + pr + '</span>' : '') +
            (free ? '<span class="msc-qa__opt-free">Free delivery</span>' : '') +
            '</button>';
        });
        html += '</div></fieldset>';
      });
    }

    if (state.showGrind) {
      html += '<fieldset class="msc-qa__field"><legend class="msc-qa__legend">Grind</legend><div class="msc-qa__opts msc-qa__opts--grind">';
      GRINDS.forEach(function (g) {
        var on = state.grind === g.value;
        html += '<button type="button" class="msc-qa__opt msc-qa__opt--grind' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-msc-qa-grind="' + esc(g.value) + '"><span class="msc-qa__opt-name">' + esc(g.label) + '</span></button>';
      });
      html += '</div></fieldset>';
    }

    var available = v && v.available;
    html += '<button type="button" class="msc-qa__add" data-msc-qa-add' + (available ? '' : ' disabled') + '>' +
      (available ? 'Add to cart — ' + fmt(v.price) : (v ? 'Sold out' : 'Unavailable')) + '</button>';
    html += '<p class="msc-qa__error" data-msc-qa-error hidden></p>';
    if (addedMsg) {
      html += '<div class="msc-qa__added" role="status"><p><strong>Added to your basket.</strong></p>' +
        '<div class="msc-qa__added-btns"><a class="msc-qa__btn msc-qa__btn--solid" href="/cart">View basket</a>' +
        '<button type="button" class="msc-qa__btn" data-msc-qa-close>Keep shopping</button></div></div>';
    }
    html += '<p class="msc-qa__more"><a href="' + esc(state.url) + '">Full details, subscriptions and brew guide →</a></p>';
    panel.innerHTML = html;

    panel.querySelectorAll('[data-msc-qa-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.picked[parseInt(b.getAttribute('data-msc-qa-opt'), 10)] = b.getAttribute('data-val');
        render();
      });
    });
    panel.querySelectorAll('[data-msc-qa-grind]').forEach(function (b) {
      b.addEventListener('click', function () { state.grind = b.getAttribute('data-msc-qa-grind'); render(); });
    });
    var add = panel.querySelector('[data-msc-qa-add]');
    if (add) add.addEventListener('click', addToCart);
  }

  function addToCart() {
    var v = currentVariant();
    if (!v || !v.available) return;
    var btn = panel.querySelector('[data-msc-qa-add]');
    var err = panel.querySelector('[data-msc-qa-error]');
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var item = { id: v.id, quantity: 1 };
    if (state.showGrind) item.properties = { Grind: state.grind };
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        refreshBubble();
        // Draft 29: the slide-in basket opens by itself after any add, so the
        // quick add panel simply closes instead of showing its own message.
        if (window.mscBasketDrawer && window.mscBasketDrawer.enabled) {
          close();
          return;
        }
        render(true);
        var added = panel.querySelector('.msc-qa__added a');
        if (added) added.focus();
      })
      .catch(function (e) {
        btn.disabled = false;
        btn.textContent = 'Add to cart — ' + fmt(v.price);
        if (err) { err.textContent = (e && (e.description || e.message)) || 'Sorry, that didn’t work. Please try again.'; err.hidden = false; }
      });
  }

  function refreshBubble() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var target = document.getElementById('cart-icon-bubble');
        if (!target || !s['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
        var inner = doc.querySelector('.shopify-section') || doc.body;
        target.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
    if (window.mscRefreshCartMessages) window.mscRefreshCartMessages();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-msc-qa-url]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    open(btn);
  });
})();
